import { useComponentContext } from '../../ComponentContext'
import ComponentSwitch from '../..'

function HandleConditionals({ condition, expectedValues, currentValue }: any) {
  switch (condition) {
    case 'not_empty':
      return currentValue !== undefined || null
    case 'empty':
      return currentValue === null
    case 'equals':
      return expectedValues?.includes(currentValue)
    case 'not_equals':
      return !expectedValues?.includes(currentValue)
    case 'contains':
      return expectedValues.some((expectedValue: any) => currentValue.includes(expectedValue))
    case 'less_than_or_equal':
      return parseFloat(currentValue) <= parseFloat(expectedValues)
    case 'greater_than_or_equal':
      return parseFloat(currentValue) >= parseFloat(expectedValues)
    case 'less_than':
      return parseFloat(currentValue) < parseFloat(expectedValues)
    case 'greater_than':
      return parseFloat(currentValue) > parseFloat(expectedValues)
    default:
      return false
  }
}

function DependantComponent({ components, key, dependsOn, condition, expectedValues }: any) {
  
  const { handleGetAnswer } = useComponentContext()

  if (HandleConditionals({ condition, expectedValues, currentValue: handleGetAnswer({ id: dependsOn }) !== undefined ? handleGetAnswer({ id: dependsOn }): dependsOn })) {
    return (
      <>
        {components.map((component: any) => (
          <ComponentSwitch {...component} key={`${key}-${component.id}`} />
        ))}
      </>
    )
  }

  return null
}

export default DependantComponent